import React, { createContext, useReducer, useContext } from "react";

import RecruitmentReducer from "../reducers/recruitmentReducer";
import * as actionTypes from "../actionTypes";
import * as urlRequest from "../urls";

import axios from "../../axios";

import { AlertContext } from "./alertState";

// -----------------------------
// Initial State
// -----------------------------

const initialState = {
  data: [],
  total: 0,
  count: 0,
  pagination: {},
  recruitment: {},
  loading: false,
  load: false,
  languages: [],
  dialects: [],
  recruitmentNotes: [],
};

// -----------------------------
// Create Context
// -----------------------------

export const RecruitmentContext = createContext(initialState);

// -----------------------------
// Provider
// -----------------------------

export const RecruitmentProvider = ({ children }) => {
  const [state, dispatch] = useReducer(RecruitmentReducer, initialState);

  const { alertDispatch } = useContext(AlertContext);

  // ----------------------------------
  // Fetch All Recruitments
  // ----------------------------------

  const getRecruitmentsHandler = async (query) => {
    dispatch({ type: actionTypes.PROCESS_START });
    console.log("query:", query);
    try {
      // console.log(urlRequest.Recruitments);
      const result = await axios.get(`${urlRequest.Recruitments}?${query}`);

      dispatch({
        type: actionTypes.FETCH_RECORDS,

        payload: {
          data: result.data.data,
          total: result.data.total,
          count: result.data.count,
          pagination: result.data.pagination,
        },
      });
    } catch (error) {
      console.log(error);

      dispatch({
        type: actionTypes.FETCH_ERRORS,
        payload: error,
      });
    }
  };

  // ----------------------------------
  // Fetch Single Recruitment
  // ----------------------------------

  const getRecruitmentHandler = async (id) => {
    dispatch({ type: actionTypes.PROCESS_START });

    try {
      const result = await axios.get(`${urlRequest.Recruitments}/${id}`);
      dispatch({
        type: actionTypes.FETCH_RECRUITMENT,
        payload: result.data,
      });
    } catch (error) {
      console.log(error);

      dispatch({
        type: actionTypes.FETCH_ERRORS,
        payload: error,
      });
    }
  };

  // ----------------------------------
  // Add Recruitment
  // ----------------------------------

  const addRecruitmentHandler = async (data) => {
    try {
      const result = await axios.post(urlRequest.Recruitments, data);

      dispatch({
        type: actionTypes.ADD_RECORD,

        payload: result.data,
      });

      if (result.data.success) {
        alertDispatch({
          type: "open",

          message: "Recruitment created",
        });
      }

      return result;
    } catch (error) {
      console.log(error);

      dispatch({
        type: actionTypes.FETCH_ERRORS,

        payload: error,
      });
    }
  };

  // ----------------------------------
  // Update Recruitment
  // ----------------------------------

  const updateRecruitmentHandler = async (data) => {
    try {
      console.log(data);
      const result = await axios.patch(
        `${urlRequest.Recruitments}/${data._id}`,

        data,
      );

      dispatch({
        type: actionTypes.UPDATE_RECORD,

        payload: result.data.data,
      });

      if (result.data.success) {
        alertDispatch({
          type: "open",

          message: "Recruitment updated",
        });
      }

      return result;
    } catch (error) {
      console.log(error);

      dispatch({
        type: actionTypes.FETCH_ERRORS,

        payload: error,
      });
    }
  };

  // ----------------------------------
  // Update Recruitment Notes
  // ----------------------------------

  const updateRecruitmentNotesHandler = async (note) => {
    try {
      const result = await axios.put(
        `${urlRequest.Recruitments}/recruitmentnote/${note.id}`,
        note,
      );

      dispatch({
        type: actionTypes.ADD_RECRUITMENT_NOTES,
        payload: result.data.data,
      });

      if (result.data.success) {
        alertDispatch({ type: "open", message: "Recruitment note added" });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: actionTypes.FETCH_ERRORS, payload: error });
    }
  };

  // ----------------------------------
  // Fetch All Languages
  // ----------------------------------
  const getLangugagesHandler = async () => {
    try {
      const result = await axios.get(urlRequest.Languages);

      dispatch({
        type: actionTypes.GET_ALL_LANGUGAGES,
        payload: result.data.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: actionTypes.FETCH_ERRORS,
        payload: error,
      });
    }
  };

  // ----------------------------------
  // Fetch All Dialects
  // ----------------------------------
  const getDialectsHandler = async () => {
    try {
      const result = await axios.get(urlRequest.Dialects);

      dispatch({
        type: actionTypes.GET_ALL_DIALECTS,
        payload: result.data.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: actionTypes.FETCH_ERRORS,
        payload: error,
      });
    }
  };

  // ----------------------------------
  // Provider Return
  // ----------------------------------

  return (
    <RecruitmentContext.Provider
      value={{
        loading: state.loading,

        data: state.data,
        total: state.total,
        count: state.count,
        pagination: state.pagination,
        isLanguages: state.languages,
        isDialects: state.dialects,

        getLangugagesHandler,
        getDialectsHandler,

        getRecruitmentsHandler,

        recruitment: state.recruitment,
        isRecruitmentNotes: state.recruitmentNotes,
        updateRecruitmentNotesHandler,

        getRecruitmentHandler,

        addRecruitmentHandler,

        updateRecruitmentHandler,
      }}
    >
      {children}
    </RecruitmentContext.Provider>
  );
};
